import { Route, Routes, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import './App.css';
import Header from '../Header/Header';
import Main from '../Main/Main';
import ModalCloser from "../ModalCloser/ModalCloser";
import Portfolio from "../Portfolio/Portfolio";
import { useState } from 'react';
import { Feedback } from '../Feedback/Feedback';
import Projects from "../Projects/Projects";

import SmallFormPopup from "../SmallFormPopup/SmallFormPopup";
import HowItWork from "../HowItWork/HowItWork";
import Tarif from "../Tarif/Tarif";
import Numbers from "../Numbers/Numbers";
import Marketplace from "../Marketplace/Marketplace";


function App() {
  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const [isFeedbackOpened, setFeedbackOpened] = useState(false);
  const [isStartPopupOpen, setIsStartPopupOpen] = useState(false)

  const onCloseFeedbackHandler = () => {
    setFeedbackOpened(isFeedbackOpened => !isFeedbackOpened);
    navigate('/');
  }

  const onFeedbackOpen = () => {
    setFeedbackOpened(true)
  }

  function openStartPopup() {
    setIsStartPopupOpen(true)
  }

  function closeStartPopup() {
    setIsStartPopupOpen(false)
  }

  const [searchParams, setSearchParams] = useSearchParams();
  if (!localStorage.getItem('referrer')) {
    const referrer = document.referrer;
    if (referrer) localStorage.setItem('referrer', referrer)
  }
  const [isUTMHandled, setIsUTMHandled] = useState(false); // Flag to control one-time execution

  const handleUTMParams = () => {
    const utmTags = {};
    let hasUTM = false;
    const date = new Date().toISOString();

    searchParams.forEach((value, key) => {
      if (key.startsWith('utm_')) {
        utmTags[key] = value;
        hasUTM = true;
      }
    });

    const gclid = searchParams.get('gclid');
    if (gclid) {
      utmTags.gclid = gclid;
      hasUTM = true;
    }

    if (hasUTM) {
      utmTags.date = date; // Add date only if UTM tags are found
      const utmHistory = JSON.parse(localStorage.getItem('utm_history')) || [];
      const isDuplicate = utmHistory.some(
        (entry) => {
          const { date: entryDate, ...entryWithoutDate } = entry;
          const { date: utmDate, ...utmTagsWithoutDate } = utmTags;
          return JSON.stringify(entryWithoutDate) === JSON.stringify(utmTagsWithoutDate);
        }
      );

      if (!isDuplicate) {
        utmHistory.unshift(utmTags); // Add new UTM tags as the latest entry
        localStorage.setItem('utm_history', JSON.stringify(utmHistory)); // Save updated history
      }

      const keysToDelete = [];
      searchParams.forEach((_, key) => {
        if (key.startsWith('utm_') || key === 'gclid') {
          keysToDelete.push(key);
        }
      });
      keysToDelete.forEach((key) => searchParams.delete(key));
      setSearchParams(searchParams, { replace: true });
    }
  };

  if (!isUTMHandled) {
    handleUTMParams();
    setIsUTMHandled(true); 
  }

  return (
    <>
      <div className="app">
        <Header onStartPopupOpen={openStartPopup}/>
        <Routes location={location || state?.backgroundLocation}>
          <Route path="/" element={<Main onFeedbackOpen={onFeedbackOpen} onStartPopupOpen={openStartPopup} isStartPopupOpen={isStartPopupOpen} />} />
          <Route path="/project/:id" element={<Portfolio />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/how-it-works" element={<HowItWork onStartPopupOpen={openStartPopup} />} />
          <Route path="/tarif" element={<Tarif onStartPopupOpen={openStartPopup} />} />
          <Route path="/marketplaces" element={<Marketplace onStartPopupOpen={openStartPopup} />} />
        </Routes>
        {state?.backgroundLocation && (
          <Routes>
            <Route path="/project/:id" element={<ModalCloser />} />
          </Routes>
        )}
        <Feedback isFeedbackOpened={isFeedbackOpened} onFeedbackOpen={onFeedbackOpen} setFeedbackOpened={setFeedbackOpened} onCloseHandler={onCloseFeedbackHandler} />
        <SmallFormPopup isOpen={isStartPopupOpen} onClose={closeStartPopup} />
        {location.pathname.includes('project') ? null : <Numbers />}
      </div>
    
    </>
  );
}

export default App;
